<template>
    <div class="parent flex-grow-1">
      <ResponsiveDesignLayer :isMedia="true" :hasImage="image ? true : false" @isFlipped="resize">
      <template v-slot:left-column>
        <div class="flex-grow" v-if="image && image.isLinks">
          <div class="mx-1 mt-2 caption_dotted" >
            Related Painted Representations
            </div>
            <div class="lazy-grid-wrapper">
              <lazyTileGrid :centered="true" @loadMore="getNextResults" :items="relatedDepictions" :itemsCount="resAmount" ></lazyTileGrid>
            </div>
        </div>
        <div v-if="image && image.isAnnotation" class="h-100">
          <div class="mx-10 d-flex flex-column justify-center h-100" >
            <div class="mx-5 d-flex justify-between align-center">
              <div v-html="getBibTitleAnno(bibliography)" style="flex: 1;" class="mx-1 mt-2 caption_dotted"></div>
              <v-btn icon :href="getAnnoLink" target="_blank" :title="null">
                <v-icon color="success">
                  mdi-content-save-outline
                </v-icon>
              </v-btn>
            </div>
            <div id="annotation" style="line-height: 1em!important;break-before: auto !important;margin: 25px!important;overflow-y: auto; " class="p-1 flex-grow" v-html="image.annotationHTML" ></div>
          </div>
        </div>
        <kuchaStudiesPDFVIew v-if="image && image.isLKS" :leipzigKuchastudiesEntry="image.LKS"/>
        <v-tabs ref="tabs"
          class="mx-1 px-3 pt-1 my-1"
          v-if="images.length > 1"
          v-model="imageTab"
          :key="tabKey"
          centered
          light
          slider-color="yellow"
          return-object
          style="color:rgba(255, 255, 255, 0.2) !important;flex:0"
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows

        >
          <v-tab
            v-for="(item, index) in images"
            :key="index"
            @click="setImage(item)"
            style="color:gba(255, 255, 255, 0.2) !important;"
          >
            <v-tooltip v-if="item && item.isLinks" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  x-large
                >
                  mdi-image-multiple-outline
                </v-icon>
              </template>
              <span>Show Related Painted Representations</span>
            </v-tooltip>

            <v-icon x-large v-else-if="item && item.isLKS">
              mdi-book-open-variant-outline
            </v-icon>
            <v-tooltip v-else-if="item && item.isAnnotation" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  x-large
                >
                  mdi-file-pdf-box
                </v-icon>
              </template>
              <span>Show Related Painted Representations</span>
            </v-tooltip>
              <v-icon x-large v-else>mdi-lock</v-icon>
            </v-tab>
        </v-tabs>
      </template>
      <template v-slot:right-column>
        <v-card-title v-html="getBibTitle(bibliography)"> </v-card-title>
          <div ref="scroll-container" class="mx-1 scroll-content w-100">
          <div :key="item_name" v-for="(item_value, item_name) in bibInfo">
            <div class="mx-1 mt-2 caption_dotted" >
              {{ item_name }}
            </div>
            <div v-if="item_name=='Related Chronology Discussions'">
              <foruminf heading="Related Chronology Discussions" :newPosts="false" @getComments="getComments()" :discussions="discussions" :chronologicalRange="getChronologicalRange"></foruminf>
            </div>
              <v-list dense>
                <v-list-item
                  v-for="(value, name, index) in item_value"
                  :key="index"
                  two-line
                >
                  <v-list-item-content class="mx-2">
                    <v-list-item-title>{{ name }}</v-list-item-title>

                    <!-- einfacher Wert -->
                    <v-list-item-subtitle v-if="typeof value !== 'object'">
                      {{ value }}
                    </v-list-item-subtitle>
                    <div v-else>
                      <v-list dense>
                        <v-list-item
                          v-for="(valueAuthors, nameAuthors, indexAuthors) in value"
                          :key="indexAuthors"
                        >
                          <v-list-item-content class="mx-2">
                            <v-list-item-title class="mx-2">{{ nameAuthors }}</v-list-item-title>
                            <v-list-item-subtitle class="mx-4">{{ valueAuthors }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
          </div>
          <div v-show="versions.length>1">
            <v-divider></v-divider>
            <div class="d-flex pa-2 mx-10 mb-1" >
              <v-combobox
              style="width:50%"
                class="d-flex justify-center align-center "
                v-model="version"
                :items="versions"
                label="Select Version"
                outlined
                dense
                item-text = "date"
                item-value="_id"
              ></v-combobox>
            </div>
          </div>
        </div>
      </template>
      </ResponsiveDesignLayer>
    </div>
</template>

<script>

import {getDepictionByBibliography, getVersionsOfEntry, getVersionOfEntry, getCommentsByItems} from '@/services/repository'
import {getBibTitle, getChronologicalRange, getLeipzigKuchastudiesEntries} from  "@/utils/helpers"
import ResponsiveDesignLayer from './ResponsiveDesignLayer.vue'
import lazyTileGrid from './lazyTileGrid.vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import "vue-pdf-app/dist/icons/main.css";
import Foruminf from '../components/foruminf.vue'
import jsPDF from 'jspdf'
import kuchaStudiesPDFVIew from '../components/leipzigKuchaStudiesPDFView.vue'

export default {
  name: 'bibliographyInf',
  props: {
    bibliographyDefault: {},
    showDepictions: true,
  },

  components: {
    VuePdfEmbed,
    Foruminf,
    ResponsiveDesignLayer,
    lazyTileGrid,
    kuchaStudiesPDFVIew
  },

  data () {
    return {
      isLoading: true,
      page: null,
      pageCount: 1,
      imageTab: 0,
      tabKey:0,
      showAllPages: true,
      relatedDepictions:[],
      showAddInf: false,
      showAnno: true,
      tab:[],
      bibliography:{},
      viewerImg:{},
      currentPage: 0,
      version:null,
      versions:['current'],
      showVersions: false,
      discussions: [],
      resAmount: 0,
      images: [],
      image: null
    }
  },
  computed: {
    getChronologicalRange(){
      return getChronologicalRange()
    },
    getAnnoLink(){
      const url = window.location.origin.includes("test") ? process.env.VUE_APP_USERREG : process.env.VUE_APP_USERREG
      return url + 'resource?annotation=' + this.bibliography.annotatedBibliographyID
    },
    bibInfo (){
      if (this.bibliography.annotatedBibliographyID){
        this.$log.debug("bibentry: ", this.bibliography);
        var bibInfo = {}
        var basciInf = {}
        var content = {}
        if (this.bibliography.abstractText !== ""){
          content["Abstract"] = this.bibliography.abstractText
        }
        if (this.bibliography.comments !== ""){
          content["Comments"] = this.bibliography.comments
        }
        if (this.bibliography.keywordList.length > 0){
          let keywords = ""
          for (let keyword of this.bibliography.keywordList){
            if (keywords === ""){
              keywords += keyword.bibKeyword
            }
          }
          basciInf["Keywords"] = keywords
        }
        if (this.bibliography.url !== ""){
          basciInf["Url"] = this.bibliography.url
        }
        if (this.bibliography.notes !== ""){
          content["Notes"] = this.bibliography.notes
        }
        if (this.bibliography.authorList.length > 0){
          let authorList = {}
          for (let authorInf of this.bibliography.authorList){
            let authorInfShown = {}
            if (authorInf.alias !== null && authorInf.alias !== "" && authorInf.alias !== undefined){
              authorInfShown["Alias"] = authorInf.alias
            }
            if (authorInf.homepage !== null && authorInf.homepage !== "" && authorInf.homepage !== undefined){
              authorInfShown["Homepage"] = authorInf.homepage
            }
            if (authorInf.firstname === null || authorInf.firstname === "" || authorInf.firstname === undefined){
              if (authorInf.lastname === null || authorInf.lastname === "" || authorInf.lastname === undefined){
                authorList[authorInf.alias] = authorInfShown
              } else {
                authorList[authorInf.lastname] = authorInfShown
              }
            } else {
              authorList[authorInf.firstname + " " + authorInf.lastname] = authorInfShown
            }
          }
          let authors = ""
          this.bibliography.authorList.length > 1 ? authors = "Authors" : authors = "Author"
          bibInfo[authors] = authorList
        }
        if (this.bibliography.editorList.length > 0){
          let editorList = {}
          for (let authorInf of this.bibliography.editorList){
            let authorInfShown = {}
            if (authorInf.alias !== null && authorInf.alias !== "" && authorInf.alias !== undefined){
              authorInfShown["Alias"] = authorInf.alias
            }
            if (authorInf.homepage !== null && authorInf.homepage !== "" && authorInf.homepage !== undefined){
              authorInfShown["Homepage"] = authorInf.homepage
            }
            if (authorInf.institutionEnabled) {
              editorList[authorInf.institution] = authorInfShown
            } else if (authorInf.firstname === null || authorInf.firstname === "" || authorInf.firstname === undefined){
              if (authorInf.lastname === null || authorInf.lastname === "" || authorInf.lastname === undefined){
                editorList[authorInf.alias] = authorInfShown
              } else {
                editorList[authorInf.lastname] = authorInfShown
              }
            } else {
              editorList[authorInf.firstname + " " + authorInf.lastname] = authorInfShown
            }
          }
          let authors = ""
          this.bibliography.editorList.length > 1 ? authors = "Editor" : authors = "Editors"
          bibInfo[authors] = editorList
        }
        if (Object.keys(basciInf).length > 0){
          bibInfo["Basic Information"] = basciInf
        }
        if (Object.keys(content).length > 0){
          bibInfo["Content"] = content
        }
        if (this.discussions.length > 0){
          bibInfo['Related Chronology Discussions'] = ''
        }

        return bibInfo
      } else {
        return {}
      }
    }
  },
  methods: {
    resize () {

    },
    generateReport () {
      let element = document.getElementById('annotation');
      var pdf = new jsPDF(); // eslint-disable-line
      pdf.html(element, {
        callback: function (pdf) {
          pdf.save();
        },
        margin: [10, 10, 10, 10],
        autoPaging: 'text',
        x: 0,
        y: 0,
        width: 650,
        windowWidth: 190,
      })
    },
    getComments(){
      getCommentsByItems([], [], [], [this.bibliography.annotatedBibliographyID])
        .then( res => {
          this.$log.debug("recieved discussions.", res.data.hits.hits)
          this.discussions = res.data.hits.hits
        }).catch(function (error) {
          this.$log.debug(error)
          return null
        })
    },
    getAllPages(){

    },
    handleDocumentRender() {
      this.isLoading = false
      this.pageCount = this.$refs.pdfRef.pageCount
    },
    getBibURL(){
      return "/bibliography/" + this.bibliography.annotatedBibliographyID
    },
    getNextResults(from, size){
      this.$log.debug("initiated next results", from, size);
      this.postSearch(from, size)
    },
    postSearch(from, size){
      var params = {}
      params.annotatedBibliographyID = [parseInt(this.bibliography.annotatedBibliographyID)]
      getDepictionByBibliography(params, from, size)
        .then( res => {
          this.resAmount = res.data.hits.total.value
          this.$log.debug("resAmount", this.resAmount);
          var found = false
          for (var image of this.images) {
            if (image.isLinks){
              if (this.resAmount == 0){
                this.images.splice(this.images.indexOf(image), 1)
                break
              } else {
                found = true
                break
              }
            }
          }
          this.$log.debug("found", found)
          if (!found){
            if (this.resAmount !== 0){
              this.$log.debug("adding links tab")
              this.images.push(
                {
                  isLinks: true
                }
              )
            }
            if (!this.image){
              this.setImage(this.images[this.images.length - 1])
            }
          }
          for (var entry of res.data.hits.hits){
            this.relatedDepictions.push(entry._source)
          }
        }).catch(function (error) {
          console.log(error)
        })

    },
    setImage(image){
      this.image = image
      this.imageTab = this.images.indexOf(image)
    },
    getRelatedDepictions(){
      if (this.showDepictions){
        this.relatedDepictions = []
        this.$log.debug("showing depictions enabled. sending request now.")
        this.postSearch(0, 20)
      }
    },
    getBibTitle(bib){
      this.$log.debug("bibentry: ", bib, getBibTitle(bib));
      return getBibTitle(bib)
    },
    getBibTitleAnno(bib){
      return "Annotation for Annotated Bibliography of " + getBibTitle(bib)
    }
  },
  mounted:function () {
    if (this.bibliography.annotationHTML){
      this.images.push({
        "isAnnotation": true,
        "annotationHTML": this.bibliography.annotationHTML.replace(/Times New Roman/g, "Tinos")
      })
    }
    const lksList = getLeipzigKuchastudiesEntries([this.bibliography])
    this.$log.debug("lksList", lksList)
    if (lksList.length > 0){
      this.$log.debug("has lksEntries", lksList)
      for (const lks of lksList){
        this.images.push({
          "isLKS": true,
          "LKS": lks
        })
        this.$log.debug("added lksEntry", this.images)
      }
    }

    this.getRelatedDepictions()
    this.getComments()
  },
  beforeMount:function () {
    this.$log.debug("beforemount:", this.bibliographyDefault);
    this.bibliography = this.bibliographyDefault
    getVersionsOfEntry(this.bibliographyDefault)
      .then( res => {
        this.$log.debug("recieved versions.", res.data.hits.hits)
        this.versions = res.data.hits.hits
        for (let v of this.versions){
          v.date = new Date(v._source.timestamp)
        }
        if (this.versions.length !== 0){
          this.versions[this.versions.length - 1].date = this.versions[this.versions.length - 1].date + " - (current)"
          this.version = this.versions[this.versions.length - 1]
          this.$log.debug("versions:", this.versions);
        }
      }).catch(function (error) {
        console.log(error);
        return null
      })
  },
  watch: {
    imageTab(newVal, oldVal){
      this.$log.debug("imageTab changed", newVal, oldVal)
    },
    bibliography(){
      this.$log.debug("new Bibliography", this.bibliography);
    },
    showAllPages() {
      this.page = this.showAllPages ? null : 1
    },
    image(newVal, oldVal){
      this.$log.debug("image changed", newVal, oldVal)
    },
    version(newVal, oldVal){
      if (newVal != null){
        getVersionOfEntry(newVal._id)
          .then( res => {
            this.bibliography = res.data._source.content
          }).catch(function (error) {
            this.$log.debug(error)
            return null
          })
      }
    }
  },
}
</script>

<style lang="css" scoped>
div >>> p {
  line-height: 1em!important;
  break-before: auto!important;
  max-width: 210mm!important;
}
.v-list{
  background-color: transparent !important;
  color: transparent !important;
}
.v-list-item__title{
  margin-bottom: 5px;
}
.v-tab {
  padding: 8px;
  min-width: 20px;
}
.vue-pdf-embed >>> div {
  margin-bottom: 8px;
  box-shadow: none;
}
.vue-pdf-embed >>> canvas {
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
.app {
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
.app-header {
  padding: 16px;
  background-color: #555;
  color: #ddd;
}

.app-content {
  padding: 24px 16px;
  overflow-y: scroll;
  background-color: #ddd;
}

.right {
  float: right;
}

</style>
